'use client';

import { useMemo, useRef, useState } from 'react';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { EntityMenuItemComponent } from '@nx-frontend/shared/ui/entity-menu';
import { FloatingPopup } from '@nx-frontend/shared/ui/floating-popup';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $workspacesAvatars } from '@nx-frontend/shared/store/workspace-avatars';
import { $workspaces } from '@nx-frontend/shared/store/workspaces';
import { WorkspaceSelectList } from './workspace-select-list';

export const WorkspaceSelect: React.FC<{ currentWorkspaceId: string }> = ({ currentWorkspaceId }) => {
  const [workspaces] = useUnit([$workspaces, $workspacesAvatars]);

  const [showDropdown, setShowDropdown] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);

  const currentWorkspace = useMemo(() => {
    return workspaces.find((org) => org.globalId === currentWorkspaceId);
  }, [currentWorkspaceId, workspaces]);

  const handleOnClose = () => {
    setShowDropdown(false);
  };

  const workspaceClick = () => {
    setShowDropdown(true);
  };

  if (!currentWorkspace) {
    return;
  }

  return (
    <>
      <div
        className={classNames('flex gap-3 p-1 items-center rounded-md cursor-pointer hover:bg-neutral-100', {
          'bg-neutral-100': showDropdown,
        })}
        onClick={workspaceClick}
      >
        <EntityMenuItemComponent
          className="!p-0 font-semibold"
          nameClass="w-36"
          item={{
            name: currentWorkspace.title,
            id: currentWorkspace.globalId,
          }}
        />
        <span>
          <Icon
            icon={IconsMap.ARROW_4_DOWN}
            className={classNames('w-5 h-5 color', {
              '-rotate-90': showDropdown,
            })}
          />
        </span>
      </div>
      <div ref={targetRef} className="relative -bottom-3"></div>
      <FloatingPopup
        show={showDropdown}
        targetRef={targetRef}
        closeButton={false}
        onClose={handleOnClose}
        className={['!p-0', '!rounded', '!min-w-60', 'mt-3']}
        containerClassName={['!p-0']}
        align={{ marginLeft: -202 }}
      >
        <WorkspaceSelectList workspaceId={currentWorkspaceId} />
      </FloatingPopup>
    </>
  );
};
